import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { StringValueComparator } from '@scale/shared-types';

interface StringComparatorBuilderProps {
  name: string;
  existingValue?: StringValueComparator;
  updateProperty: (arg: StringValueComparator) => void;
  required?: boolean;
}

interface ComparatorOption {
  id: StringValueComparator;
  name: string;
}

const comparatorOptions: Array<ComparatorOption> = Object.values(StringValueComparator).map(
  comparator => {
    return { id: comparator, name: comparator };
  },
);

const StringComparatorBuilder: React.FC<StringComparatorBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
  required,
}) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        {name && <div className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      </div>
      <SelectMenu
        className="min-w-[135px]"
        options={comparatorOptions}
        selectedOptionId={existingValue || StringValueComparator.Equals}
        setSelected={value => {
          updateProperty(value as StringValueComparator);
        }}
        required={required}
      />
    </div>
  );
};

export default StringComparatorBuilder;
